import { Component, EventEmitter, Input, Output, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RX_STATE_OPTIONS } from './rx-state-options';

@Component({
  selector: 'rx-states',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    NgSelectModule,
  ],
  templateUrl: './rx-states.component.html',
  styleUrls: ['./rx-states.component.scss'],
})
export class RxStatesComponent {
  @Input() placeholder = '';
  @Input() hidePlaceHolder = false;
  @Input() field: any;
  @Output() modelChangeEmit = new EventEmitter<any>();

  public ngOnInit() {
    // ngOnInit logic (if any) goes here
  }
  public options: any[] = [...RX_STATE_OPTIONS];

  private searchSubject = new Subject<string>();

  highlightMatch(text: string, searchTerm: string): string {
    if (!searchTerm || !text) return text ?? '';
    const regex = new RegExp(`(${this.escapeRegExp(searchTerm)})`, 'gi');
    return text.replace(regex, '<strong>$1</strong>');
  }

  private escapeRegExp(s: string) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  public trackByFn(index: number, item: any): any {
    return item?.value || index;
  }

  public onSearch(event: { term: string; items: any[] }): void {
    const newSearchTerm = event.term || '';
    this.searchSubject.next(newSearchTerm);
  }

  getPlaceholder(): string {
    if (this.hidePlaceHolder) {
      return '';
    }
    return this?.field?.placeholder || 'Select State';
  }
}
